import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { StyledAccordionSummary } from './Accordion.styles';
import type { AccordionSummaryProps } from './Accordion.types';

/**
 * Primitive AccordionSummary component with responsive padding
 * Header section that expands/collapses the accordion
 */
export const AccordionSummary: React.FC<AccordionSummaryProps> = ({
  expandIcon = <ExpandMoreIcon />,
  children,
  ...props
}) => {
  return (
    <StyledAccordionSummary expandIcon={expandIcon} {...props}>
      {children}
    </StyledAccordionSummary>
  );
};